import React, { useState, useContext, useEffect, useRef } from 'react'
import Layout from "../../../components/layout"
import { HeaderWrapper, ContentWrapper } from './style'
import Input from '../../../components/Input'
import AddProduct from "../AddProduct";
import { AuthContext } from '../../../context/auth';
import ItemPreviewDrawer from '../../../components/Drawers/ItemPreviewDrawer';
import Pagination from '../../../components/pagination';
import { getProductsApi, getProductCategoriesApi } from '../../../api'
import DeleteProductModal from '../../../components/modals/DeleteProductModal';
import Coa from '../../../components/coA'
import { useDebounce } from 'use-debounce'
const Index = () => {
  const coARef = useRef(null)
  const { setOpenItemPreviewModal, openItemPreviewModal, setIsLoading, setOpenDeleteProductModal, openDeleteProductModal } = useContext(AuthContext)
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [products, setProducts] = useState([])
  const [productCategory, setProductCategory] = useState(null)
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState('')
  const [sort, setSort] = useState({
    name: 'title',
    type: 'title'
  })
  const [debouncedSearch] = useDebounce(search, 300);
  // const businessData = [
  //   {

  //     cat: "PA000001",
  //     host_species: "Mouse Monoclonal",
  //     price: "$99.99",
  //     target: "PARP1",
  //     product_name: "Anti-Human PARP1",
  //   },
  //   {

  //     cat: "PA000001",
  //     host_species: "Mouse Monoclonal",
  //     price: "$99.99",
  //     target: "PARP1",
  //     product_name: "Anti-Human PARP1",
  //   },
  //   {

  //     cat: "PA000001",
  //     host_species: "Mouse Monoclonal",
  //     price: "$99.99",
  //     target: "PARP1",
  //     product_name: "Anti-Human PARP1",
  //   },

  //   {

  //     cat: "PA000001",
  //     host_species: "Mouse Monoclonal",
  //     price: "$99.99",
  //     target: "PARP1",
  //     product_name: "Anti-Human PARP1",
  //   },

  //   {

  //     cat: "PA000001",
  //     host_species: "Mouse Monoclonal",
  //     price: "$99.99",
  //     target: "PARP1",
  //     product_name: "Anti-Human PARP1",
  //   },

  //   {

  //     cat: "PA000001",
  //     host_species: "Mouse Monoclonal",
  //     price: "$99.99",
  //     target: "PARP1",
  //     product_name: "Anti-Human PARP1",
  //   },

  //   {

  //     cat: "PA000001",
  //     host_species: "Mouse Monoclonal",
  //     price: "$99.99",
  //     target: "PARP1",
  //     product_name: "Anti-Human PARP1",
  //   },

  //   {

  //     cat: "PA000001",
  //     host_species: "Mouse Monoclonal",
  //     price: "$99.99",
  //     target: "PARP1",
  //     product_name: "Anti-Human PARP1",
  //   },

  //   {

  //     cat: "PA000001",
  //     host_species: "Mouse Monoclonal",
  //     price: "$99.99",
  //     target: "PARP1",
  //     product_name: "Anti-Human PARP1",
  //   },

  //   {

  //     cat: "PA000001",
  //     host_species: "Mouse Monoclonal",
  //     price: "$99.99",
  //     target: "PARP1",
  //     product_name: "Anti-Human PARP1",
  //   },


  // ];


  const fetchProductCategories = () => {
    setIsLoading(true)
    getProductCategoriesApi()
      .then(res => {
        if (res && res.data?.product_categories && res.data?.product_categories.length > 0) {
          if (res?.data?.product_categories?.find((item) => item?.name == 'Alexa Flour Primary Antibodies')) {
            setProductCategory(res?.data?.product_categories?.find((item) => item?.name == 'Alexa Flour Primary Antibodies'))
            // getProductsApi(res?.data?.product_categories?.find((item) => item?.name == 'Alexa Flour Primary Antibodies')?.id, 10, currentPage, search).then(res => {
            //   if(res && res.data) {
            //     setProducts(res?.data)
            //     setIsLoading(false)
            //   }
            //   setIsLoading(false)
            // }).catch(err => {
            //   console.error(err)
            //   setIsLoading(false)
            // })
          } else {
            setProductCategory(null)
            setIsLoading(false)
          }
        } else {
          setProductCategory(null)
          setProducts([])
          setIsLoading(false)
        }
      })
      .catch(err => {
        console.error(err)
        setIsLoading(false)
      })
  }


  const fetchProduct = () => {
    setIsLoading(true)
    getProductsApi(productCategory?.id, 10, currentPage * 10, search, sort).then(res => {
      if (res && res.data) {
        setProducts(res?.data)
        setIsLoading(false)
      }
      setIsLoading(false)
    }).catch(err => {
      console.error(err)
      setIsLoading(false)
    })
  }


  useEffect(() => {
    if (!openAddProduct) {
      setSelectedProduct(null)
    }
  }, [openAddProduct])


  useEffect(() => {
    fetchProductCategories()
  }, [openAddProduct])

  useEffect(() => {
    if (productCategory) {
      fetchProduct()
    }
  }, [debouncedSearch, currentPage, productCategory, sort.type, sort.name])



  if (openAddProduct) {
    return <AddProduct setOpenAddProduct={setOpenAddProduct} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} type={'DC - Primary Antibody Direct Conjugate'} />
  }

  return (
    <>
      <Layout>
        <HeaderWrapper>
          <div className="header-title">Products - <span className='sub-title'>Alexa Fluor™ Primary Antibodies</span> {products.count > 0 && `(${products.count})`}</div>
          <div className="header-search-container">
            <Input type="text" search style={{ height: '40px', paddingLeft: '30px' }} placeholder={'Search'} value={search} onChange={(e) => setSearch(e.target.value)} />
            <button className='btn' onClick={() => setOpenAddProduct(true)}>Add New Product</button>
          </div>
        </HeaderWrapper>
        <ContentWrapper>
          {products && products?.products?.length > 0 ?
            <>
              <table className={"mainTable"}>
                <thead>
                  <tr>
                    <th>Cat ID# </th>
                    <th style={{ cursor: 'pointer' }} onClick={() => {
                      if(sort.type === 'subtitle'){
                        if(sort.name === 'subtitle'){
                          setSort({
                            name:'-subtitle',
                            type:'subtitle'
                          })
                        }else{
                          setSort({
                            name:'subtitle',
                            type:'subtitle'
                          })
                        }
                      }else{
                        setSort({
                          name:'subtitle',
                          type:'subtitle'
                        })
                      }
                    }}>Target {sort.type === 'subtitle' && <i className={sort.name === 'subtitle' ? 'fas fa-chevron-down' : 'fas fa-chevron-up'} style={{ fontSize: '11px', color: '#6c6a73' }}></i>}</th>
                    <th style={{ cursor: 'pointer' }} onClick={() => {
                      if(sort.type === 'title'){
                        if(sort.name === 'title'){
                          setSort({
                            name:'-title',
                            type:'title'
                          })
                        }else{
                          setSort({
                            name:'title',
                            type:'title'
                          })
                        }
                      }else{
                        setSort({
                          name:'title',
                          type:'title'
                        })
                      }
                    }}>Product Name {sort.type === 'title' && <i className={sort.name === 'title' ? 'fas fa-chevron-down' : 'fas fa-chevron-up'} style={{ fontSize: '11px', color: '#6c6a73' }}></i>}</th>
                    <th>Host Species</th>
                    <th style={{ cursor: 'pointer' }} onClick={() => {
                      if(sort.type === 'dyes'){
                        if(sort.name === 'dyes'){
                          setSort({
                            name:'-dyes',
                            type:'dyes'
                          })
                        }else{
                          setSort({
                            name:'dyes',
                            type:'dyes'
                          })
                        }
                      }else{
                        setSort({
                          name:'dyes',
                          type:'dyes'
                        })
                      }
                    }}>Dye Line {sort.type === 'dyes' && <i className={sort.name === 'dyes' ? 'fas fa-chevron-down' : 'fas fa-chevron-up'} style={{ fontSize: '11px', color: '#6c6a73' }}></i>}</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {products?.products?.map((business) => {
                    return (
                      <tr
                        key={business?.id}
                      >
                        <td>
                          {business?.material ? business?.mid_code + " " + business?.material : "-"}
                        </td>
                        <td>
                          {business?.subtitle ? business?.subtitle : "-"}
                        </td>
                        <td style={{ width: '300px' }}>
                          {business?.title ? business?.title : "-"}
                        </td>
                        <td>
                          {business?.host ? business?.host + " " + business?.clonality : "-"}
                        </td>
                        <td>
                          {business?.dyes ? business?.dyes : "xxx"}
                        </td>
                        <td><span style={{ fontWeight: 600 }}>${business?.variants[0]?.prices[0] ? (business?.variants[0]?.prices[0]?.amount / 100)?.toFixed(2) : "-"}</span></td>
                        <td><span style={{ fontWeight: 600, color: business?.variants[0]?.inventory_quantity ? "#1E1E1E" : "#DC1E00" }}>{business?.variants[0]?.inventory_quantity ? business?.variants[0]?.inventory_quantity : "Out of Stock"}</span></td>
                        <td style={{ cursor: "pointer" }}>
                          <span style={{ display: 'flex', gap: '30px', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <button style={{ fontSize: '16px', color: '#6c6a73' }} onClick={() => {
                              setOpenItemPreviewModal(true)
                              setSelectedProduct(business)
                            }}><i class="fal fa-eye"></i></button>
                            <button style={{ fontSize: '16px', color: '#6c6a73' }} onClick={() => {
                              setOpenAddProduct(true)
                              setSelectedProduct(business)
                            }}><i class="fal fa-pencil"></i></button>
                            <button style={{ fontSize: '16px', color: '#6c6a73' }}
                              onClick={() => {
                                setSelectedProduct(business)
                                setOpenDeleteProductModal(true)
                              }}
                            ><i class="fal fa-trash-alt"></i></button>
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
             {products?.count / products.limit > 1 && <Pagination total={products?.count / products.limit} setCurrentPage={setCurrentPage} currentPage={currentPage} /> }
            </>
            : <div className='no-orders'>
              <span className='icon'>
                <i class="fal fa-boxes"></i>
              </span>
              <p>No Products Yet.</p>
            </div>
          }
          <div className="print-map" style={{ display: 'none' }}>
            <Coa reference={coARef} selectedProduct={selectedProduct} productCategory={selectedProduct?.mid_code.search("PA") >= 0 ? 'PA' : selectedProduct?.mid_code.search("SA") >= 0 ? 'SA' : 'DC'}  />
          </div>
        </ContentWrapper>
      </Layout>
      {openItemPreviewModal && <ItemPreviewDrawer setOpenItemPreviewModal={setOpenItemPreviewModal} setOpenAddProduct={setOpenAddProduct} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} coARef={coARef} />}
      {
        openDeleteProductModal && <DeleteProductModal selectedProduct={selectedProduct} fetchProducts={fetchProduct} />
      }
    </>
  )
}

export default Index